import type { Connector, IndexedDBConnector, ApiConnector } from '@/types/accessor/common/connector'
import type { ApiName } from '@/types/accessor/api/common/apiName'
import * as api from '../api'
import * as indexedDB from '../indexedDB'

/**
 * connector生成用関数
 * @Param { controllerName } connectorを指定するための文字列
 * @return Connector | undefined
 */
export const connectorFactory = (controllerName: ApiName): Connector | undefined => {
  return connectorList.find(c => c.name === controllerName)
}

/** 何もしない関数（オンライン時のみ動作してほしい場合などに使用する */
const apiConnectorDummy: ApiConnector = async () => {}
const indexedDBConnectorDummy: IndexedDBConnector = async () => {}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const connectorList: Connector<any, any, any>[] = [
  {
    name: 'test',
    api: apiConnectorDummy,
    indexedDB: {
      forApi: indexedDBConnectorDummy,
      forMain: indexedDBConnectorDummy
    }
  },
  {
    name: 'queryBuildingDaoApi',
    api: api.building.query,
    indexedDB: {
      forApi: indexedDB.building.set,
      forMain: indexedDB.building.getAll
    }
  },
  {
    name: 'queryGovernmentSettingDaoApi',
    api: api.governmentSettings.query,
    indexedDB: {
      forApi: indexedDB.governmentSettings.set,
      forMain: indexedDB.governmentSettings.get
    }
  },
  {
    name: 'queryDisasterDaoApi',
    api: api.disaster.query,
    indexedDB: {
      forApi: indexedDB.disaster.set,
      forMain: indexedDB.disaster.getAll
    }
  },
  {
    name: 'queryInspectionResultApi',
    api: api.inspectionResult.query,
    indexedDB: {
      forApi: indexedDB.inspectionResult.setAll,
      forMain: indexedDB.inspectionResult.query
    }
  },
  {
    name: 'upsertInspectionResultApi',
    api: api.inspectionResult.upsert,
    indexedDB: {
      forApi: indexedDB.inspectionResult.setOnlyUpdated,
      forMain: indexedDB.inspectionResult.update
    }
  },
  {
    name: 'queryAdminDistrictsDaoApi',
    api: api.adminDistricts.query,
    indexedDB: {
      forApi: indexedDB.adminDistricts.set,
      forMain: indexedDB.adminDistricts.get
    }
  },
  {
    /**
     * ※invからの移植
     * NOTE:
     * すでにqueryAdminDistrictsDaoApiがあるが、IDBからデータを取得してしまう
     * オンラインのみ動作してほしいためIDB取得はDummyのオンライン専用Connectorを作成
     * 特殊ケースかと思われるが、今後も「同じAPIだがオンラインのみ動作させたい場合がある」ことが多くなるようであれば
     * DataAccessorBasedOnNetwork.tsに関数を追加するなど検討する
     */
    name: 'queryAdminDistrictsDaoApiOnlineOnly',
    api: api.adminDistricts.query,
    indexedDB: {
      forApi: indexedDBConnectorDummy,
      forMain: indexedDBConnectorDummy
    }
  }
]
